<template>
  <div class="empty">
    <img class="image" :src="emptySrc" alt="Empty" />
    <div class="text">{{ text || t('lang006') }}</div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { getPartyHeroImage } from '@/common/utils';

defineProps({ text: [String, Boolean] });

const { t } = useI18n();
const emptySrc = getPartyHeroImage('empty.png');
</script>

<style lang="less" scoped>
.empty {
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .image {
    width: 100px;
  }

  .text {
    margin-top: 4px;
    color: var(--color-text-3);
    font-size: 10px;
  }
}
</style>
